import { ConditionComponent, getComparatorIds } from './condition-component';
import { getComparatorLabel, getValueLabel } from './label-helpers';

import { setConditionHelpers } from '../sidebars/add-webhook-condition';
import { setWebhookLabelHelpers } from '../webhook-card';

export { useConditionComparators } from './comparators';
export { ComparatorComponent, ComparatorValueContainer } from './comparator-component';
export { ConditionComponent, getComparatorIds } from './condition-component';
export type { Condition } from './condition-component';
export { getComparatorLabel, getValueLabel } from './label-helpers';
export {
  filterSelectAttributeVariables,
  findMappedField,
  findValueOptions,
  findValueType,
  reconcileValueWithOptions,
  toValueOption,
} from './field-utils';
export {
  Conditions,
  useConditionState,
  processConditionsForSubmission,
  type ConditionType,
} from './conditions';

/**
 * Initializes the condition helpers for the integrations module.
 * Call this once at app startup to enable webhook conditions functionality.
 */
export const initializeConditionHelpers = () => {
  setConditionHelpers({
    ConditionComponent,
    getComparatorIds,
  });

  setWebhookLabelHelpers({
    getComparatorLabel,
    getValueLabel,
  });
};
